import { sectionRoutes } from '../helpers';

export const WORKFLOW_CONFIGURATION_ROUTES = sectionRoutes({
  meta: { adminTab: 'Workflow Configuration' },
  tabKey: 'workflowTab',
  routes: [
    ['workflow-configuration/task-statuses', 'AdminWorkflowTaskStatuses', 'task-statuses'],
    ['workflow-configuration/instruction-types', 'AdminWorkflowInstructionTypes', 'instruction-types'],
    ['workflow-configuration/task-configuration', 'AdminWorkflowTaskConfiguration', 'task-configuration'],
    ['workflow-configuration/task-configuration/:taskTypeId(\\d+)', 'AdminWorkflowTaskConfigurationDetail', 'task-configuration'],
    ['workflow-configuration/metric-workflows', 'AdminWorkflowMetricWorkflows', 'metric-workflows'],
    ['workflow-configuration/metric-workflows/:metricId(\\d+)', 'AdminWorkflowMetricWorkflowDetail', 'metric-workflows'],
    ['workflow-configuration/work-types', 'AdminWorkflowWorkTypes', 'work-types'],
    ['workflow-configuration/programs', 'AdminWorkflowPrograms', 'programs'],
  ],
});
